import checkmarkIcon from '/assets/checkmark-big-circle.svg';
import useSettings from '@/hooks/useSettings';

const pixAdvantage = [
  { icon: checkmarkIcon, message: 'Liberação imediata' },
  { icon: checkmarkIcon, message: 'É simples, só usar o aplicativo de seu banco para pagar Pix' }
];

export function PixForm() {
  const settings = useSettings();

  return (
    <>
      <div
        style={{
          borderWidth: '2.3px'
        }}
        className="rounded-md border border-[#0F7864] border-dashed border border- p-3"
      >
        <ul>
          {pixAdvantage.map(({ icon, message }) => (
            <li key={message} className="flex items-center py-1 px-3 xs:px-1">
              <img src={icon} alt="Checkmark Icon" style={{ height: '18px', width: '18px' }} />
              <p
                style={{ color: settings.text.color.primary }}
                className="text-[14px] text-white text-bold leading-[24px] ml-2"
              >
                {message}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
